<template>
  <section class="content">
      Proccesing
  </section>
</template>

<script>
  import MainLayout from '../layouts/Main.vue';
  import axios from 'axios';
  import VueScrollTo from 'vue-scrollto';

  var APIbase = "https://yard-bands.herokuapp.com";

  export default {
    components: {
      MainLayout
    },
    created() {
        window.parent.postMessage("yardbands_payment_confirm", "*");
    },
    destroyed() {
      window.removeEventListener('resize', this.windowResized);
    },
    data() {
      return {
        userName: '',
        instrument: '',
        auditionType: '',
        deal_id: '',
        hour: '',
        day: '',
        email: ''
      };
    },
    methods: {

    }
  };
</script>



// WEBPACK FOOTER //
// Payment_confirm.vue?31df96d8